import { datesComparator } from '@/utils/Dates';
import { cleanString } from '@/utils/Format';

// to compare values and order lists
export const order = (order, orderBy, type) => {
    
    return order === 'desc' ? 
        (a, b) => descendingComparator(a, b, orderBy, type)
    : 
        (a, b) => -descendingComparator(a, b, orderBy, type);
}

// to compare values and order lists but on the ag grid
export const orderTable = (column,value1,value2,node1,node2,isDescending,type = 'string',options = null) => {

    // for the table it works different to common sort
    let stringValues1;
    let stringValues2;
    let result;
    switch(type){

        case 'dropdown':
        case 'dropdown_search':
        case 'dropdown_multiple':
    
            // change values to string
            if(type === 'dropdown_multiple'){

                stringValues1 = '';
                value1 && Object.keys(value1)?.map((key) => {
                    var value = value1[key];
                    stringValues1 += value?.name;
                });

                stringValues2 = '';
                value2 && Object.keys(value2)?.map((key) => {
                    var value = value2[key];
                    stringValues2 += value?.name;
                });
            }
            else{
                stringValues1 = options[value1]?.name;
                stringValues2 = options[value2]?.name;
            }

            result = descendingComparator(stringValues1,stringValues2,null,'string');
            break;

        case 'datetime':
        case 'datetime_offset':
        case 'date':
        case 'hour':
            result =  -descendingComparator(value1,value2,null,type);
            break;
    
        default:
            result =  descendingComparator(value1,value2,null,type);
            break;
    }

    return result;
}

export const descendingComparator = (a, b, orderBy = null, type = 'string') => {

    var result = 0; // same

    let value1;
    let value2;
    let isNotValid1;
    let isNotValid2;
    if(orderBy){
        value1 = b[orderBy];
        value2 = a[orderBy];
    }
    else{
        // if ordering tables
        value1 = a;
        value2 = b;
    }

    switch(type){

        case 'boolean':
            var value1bool = 1;
            if(!value1 || value1 === null || value1 === false){
                value1bool = 0;
            }

            var value2bool = 1;
            if(!value2 || value2 === null || value2 === false){
                value2bool = 0;
            }

            if(value1bool < value2bool){
                result = -1;
            }
            else{
                if(value1bool > value2bool){
                    result = 1;
                }
                else{
                    result = 0;
                }
            }
            break;

        case 'numerical':

            // if empty value, fill in with -1 to be the 1st
            // we don't have negative numbers on the list, so no problem
            isNotValid1 = !value1 || value1 == '';
            isNotValid2 = !value2 || value2 == '';

            if(isNotValid1){
                value1 = -1;
            }
            
            if(isNotValid2){
                value2 = -1;
            }

            if(value1 < value2){
                result = -1;
            }
            else{
                if(value1 > value2){
                    result = 1;
                }
                else{
                    result = 0;
                }
            }
        
            break;
        
        case 'date':
        case 'datetime':
        case 'datetime_offset':
        case 'dateSpanishSlash':
        case 'dateSpanishDash':
        case 'hour':

            var format = 'YYYY-MM-DD';
            var split;

            switch(type){

                case 'datetime':
                case 'datetime_offset':
                    format = 'YYYY-MM-DD hh:mm:ss';
                    break;

                case 'dateSpanishSlash':

                    split = value1.split(' ');

                    // with hour
                    format = 'DD/MM/YYYY';
                    if(split.length > 1){
                        format = format+ ' hh:mm:ss';
                    }
                    break;

                case 'dateSpanishDash':

                    split = value1.split(' ');

                    // with hour
                    format = 'DD-MM-YYYY';
                    if(split.length > 1){
                        format = format+ ' hh:mm:ss';
                    }                  
                    break;

                case 'hour':
                    format = 'hh:mm:ss';
                    break;
                /*
                case 'date':
                default:
                    break;
                */
            }          

            result = datesComparator(value1,value2,format);  
            break;

        case 'string':        

            isNotValid1 = !value1 || value1.length === 0;
            isNotValid2 = !value2 || value2.length === 0;

            if(isNotValid1){

                if(isNotValid2){
                    result = 0; // same
                }
                else{
                    result = -1; // b < a 
                }
            }
            else{
                // b with value but a empty
                if(isNotValid2){
                    result = 1; // b > a 
                }
                else{
                    // 1st < 2nd => -1
                    // 1st > 2nd => 1
                    // otherwise 0                    
                    var value1formatted = cleanString(value1?.toLowerCase());
                    var value2formatted = cleanString(value2?.toLowerCase());

                    var compare = value1formatted.localeCompare(value2formatted);            
                    result = compare;
                }
            }
            break;
    }

    return result;
}